webpackJsonp([113974542038641],{

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _glamor = __webpack_require__(10);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(47);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _lodash = __webpack_require__(73);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  title: (0, _glamor.style)({
	    fontSize: '32px',
	    marginBottom: '2px'
	    // '@media(max-width: 460px)': {
	    //   maxWidth: '100%',
	    // },
	  }),
	  date: (0, _glamor.style)({
	    fontSize: '14px'
	  }),
	  characterLink: (0, _glamor.style)({
	    fontSize: '12px'
	  }),
	  img: (0, _glamor.style)({
	    // maxWidth:'600px'
	  })
	};
	
	exports.default = function (_ref) {
	  var _ref$node = _ref.node,
	      title = _ref$node.title,
	      date = _ref$node.date,
	      image = _ref$node.image,
	      characters = _ref$node.characters;
	  return Glamor.createElement(
	    'fragment',
	    null,
	    Glamor.createElement(
	      'h2',
	      { className: styles.title },
	      title
	    ),
	    Glamor.createElement(
	      'div',
	      { className: styles.date },
	      new Date(date).toLocaleDateString()
	    ),
	    Glamor.createElement('img', { className: styles.img, src: _lodash2.default.get(image, 'file.url') }),
	    Glamor.createElement(
	      'div',
	      null,
	      characters && Glamor.createElement(
	        'span',
	        { className: styles.characterLink },
	        'Characters: '
	      ),
	      characters && characters.map(function (_ref2) {
	        var title = _ref2.title,
	            contentful_id = _ref2.contentful_id;
	
	        var link = '/character/' + contentful_id;
	
	        return Glamor.createElement(
	          _gatsbyLink2.default,
	          { key: contentful_id, to: link, className: styles.characterLink },
	          '[',
	          title,
	          ']'
	        );
	      })
	    )
	  );
	};
	
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Cartoon = __webpack_require__(249);
	
	var _Cartoon2 = _interopRequireDefault(_Cartoon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var cartoons = _ref.cartoons;
	
	
	  if (!cartoons) return null;
	
	  return Glamor.createElement(
	    "div",
	    null,
	    cartoons.map(function (_ref2) {
	      var node = _ref2.node;
	      return Glamor.createElement(_Cartoon2.default, _extends({ key: node.contentful_id }, { node: node }));
	    })
	  );
	};
	
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	exports.NavLink = exports.disabled = exports.navButtons = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(47);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _glamor = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var navButtons = exports.navButtons = (0, _glamor.css)({
	  textDecoration: 'none',
	  display: 'inline-block',
	  padding: '8px 16px',
	  borderRadius: '50%'
	});
	
	var disabled = exports.disabled = (0, _glamor.css)({
	  color: 'gray'
	});
	
	var _ref = navButtons;
	var _ref2 = navButtons;
	var _ref3 = disabled;
	var NavLink = exports.NavLink = function NavLink(props) {
	  if (!props.test) {
	    return Glamor.createElement(
	      _gatsbyLink2.default,
	      _extends({ to: props.url }, (0, _glamor.css)(_ref)),
	      props.children
	    );
	  } else {
	    return Glamor.createElement(
	      'span',
	      (0, _glamor.css)(_ref2, _ref3),
	      props.children
	    );
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _NavLink = __webpack_require__(255);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Cartoons = __webpack_require__(250);
	
	var _Cartoons2 = _interopRequireDefault(_Cartoons);
	
	var _glamor = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var navBar = (0, _glamor.css)({
	  fontSize: '150%'
	});
	
	var _ref = navBar;
	
	exports.default = function (_ref2) {
	  var pathContext = _ref2.pathContext;
	  var group = pathContext.group,
	      index = pathContext.index,
	      first = pathContext.first,
	      last = pathContext.last,
	      pageCount = pathContext.pageCount,
	      totalCount = pathContext.additionalContext.totalCount;
	
	  var previousUrl = index - 1 == 1 ? "" : (index - 1).toString();
	  var nextUrl = (index + 1).toString();
	
	  return Glamor.createElement(
	    "div",
	    null,
	    Glamor.createElement(
	      "h4",
	      null,
	      totalCount,
	      " Posts "
	    ),
	    Glamor.createElement(_Cartoons2.default, { cartoons: group }),
	    pageCount > 1 && Glamor.createElement(
	      "div",
	      _extends({}, (0, _glamor.css)(_ref), { className: "previousLink" }),
	      Glamor.createElement(
	        _NavLink.NavLink,
	        { test: first, url: previousUrl },
	        "\xAB\xA0\xA0Prev"
	      ),
	      index,
	      "/",
	      pageCount,
	      Glamor.createElement(
	        _NavLink.NavLink,
	        { test: last, url: nextUrl },
	        "Next\xA0\xA0\xBB"
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-cartoons-js-c4dd7be0e320787d7002.js